import { FC, createContext } from 'react';
import { types, Instance } from 'mobx-state-tree';
import { useLocalObservable } from 'mobx-react-lite';
import { MainStore } from './stores/main/main.store';
import { AlertStore } from './components/Core/CustomAlert/store';
import { TableStore } from './stores/table/table.store';
import { PopUpStore } from './stores/popUp/popUp.store';
import { PointsStore } from 'stores/points/points.store';
import { UsersStore } from 'stores/users/users.store';
import { RequestsStore } from 'stores/requests/requests.store';
import { BrandsStore } from 'stores/brands/brands.store';
import { ProductsStore } from 'stores/products/products.store';
import { DEFAULT_POINT_QUERY } from 'stores/points/constatnts';
import { DEFAULT_PRODUCT_QUERY } from 'stores/products/constatnts';
import { ReviewsStore } from 'stores/reviews/reviews.store';
import { ParsersStore } from 'stores/parsers/parsers.store';
import { DEFAULT_BRAND_QUERY } from 'stores/brands/constants';
import { CountriesStore } from 'stores/countries/countries.store';
import { PopularProductsStore } from 'stores/popularProducts/popularProducts.store';
import { ElasticStore } from 'stores/elastic/elastic.store';
import { CategoriesStore } from 'stores/categories/categories.store';
import { ScriptsStore } from 'stores/scripts/scripts.store';
import { SearchCoverageStore } from 'stores/searchCoverage/searchCoverage.store';

const { model } = types;

export const RootStore = model('RootStore', {
  mainStore: MainStore,
  popUpStore: PopUpStore,
  alertStore: AlertStore,
  tableStore: TableStore,
  pointsStore: PointsStore,
  brandsStore: BrandsStore,
  usersStore: UsersStore,
  requestsStore: RequestsStore,
  productsStore: ProductsStore,
  reviewsStore: ReviewsStore,
  parsersStore: ParsersStore,
  countriesStore: CountriesStore,
  popularProductsStore: PopularProductsStore,
  elasticStore: ElasticStore,
  categoriesStore: CategoriesStore,
  scriptsStore: ScriptsStore,
  searchCoverageStore: SearchCoverageStore,
});

export type IRootStore = Instance<typeof RootStore>;

export const RootStoreContext = createContext<IRootStore | null>(null);

export const RootStoreProvider: FC = ({ children }) => {
  const store = useLocalObservable(() =>
    RootStore.create({
      mainStore: {
        globalLoading: false,
      },
      popUpStore: {},
      alertStore: {
        message: '',
        show: false,
        type: 'error',
      },
      tableStore: { startPageIndex: 0 },
      pointsStore: {
        isPoint: false,
        pointsQuery: DEFAULT_POINT_QUERY,
        pointsBasicLogsQuery: {},
        pointsCategories: [],
      },
      brandsStore: {
        // brandsCount: 0,
        isBrand: false,
        brandsQuery: DEFAULT_BRAND_QUERY,
        brandCataloguesFilters: {},
        elasticCountsMap: {},
      },
      usersStore: {},
      requestsStore: {
        requestsBrandsCount: 0,
        requestsPointsCount: 0,
        requestsProductsCount: 0,
        requestsCataloguesCount: 0,
      },
      productsStore: { productsQuery: DEFAULT_PRODUCT_QUERY },
      reviewsStore: {},
      parsersStore: {},
      countriesStore: {},
      popularProductsStore: {},
      elasticStore: {},
      categoriesStore: {},
      scriptsStore: {},
      searchCoverageStore: {},
    })
  );
  return <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>;
};
